const agencyType = [
  {
    agencyTypeId: 1,
    agencyTypeName: "ภาครัฐ",
    createDate: "2022-03-04T22:04:03.000Z",
    lastUpdate: "2022-03-04T22:04:03.000Z",
  },
  {
    agencyTypeId: 2,
    agencyTypeName: "ภาคเอกชน",
    createDate: "2022-03-04T22:04:03.000Z",
    lastUpdate: "2022-03-04T22:04:03.000Z",
  },
  {
    agencyTypeId: 3,
    agencyTypeName: "การศึกษา",
    createDate: "2022-08-25T21:43:32.000Z",
    lastUpdate: "2022-08-25T23:28:14.000Z",
  },
  {
    agencyTypeId: 4,
    agencyTypeName: "บุคคลทั่วไป",
    createDate: "2022-08-25T21:43:56.000Z",
    lastUpdate: "2022-08-25T23:28:29.000Z",
  },
];
export default agencyType;
